import * as React from 'react';
import cn from 'clsx';
import { UIText1 } from '@cian/ui-kit/typography';

import { NBSP } from '../../../../constants/symbols';

import * as styles from './styles.css';

export interface IAsideProps {
  backToPage: React.ReactNode;
  withSaleRentIntro?: boolean;
}

export function Aside({ backToPage, withSaleRentIntro }: IAsideProps) {
  return (
    <>
      {backToPage}
      <h1 className={cn(styles['title'], { [styles['title-sale-rent']]: withSaleRentIntro })}>
        {withSaleRentIntro ? 'Куплю/Сниму на Циан' : 'Заявка риелтору'}
      </h1>
      <div className={styles['description']}>
        <UIText1>
          Информация из этой анкеты поможет подходящему риелтору найти вашу заявку и{NBSP}обработать её. Комиссия за
          {NBSP}услуги обсуждается с{NBSP}риелтором
        </UIText1>
      </div>
      <div
        className={cn(styles['img'], {
          [styles['img-sale-rent']]: withSaleRentIntro,
        })}
      />
    </>
  );
}
